<template>
  <div>
    <Loader v-if="!appointments || fetching" style="width: 100%;" />
    <admin-requests-table v-else
                          :appointments="appointments"
                          :count="count"
                          :pagination="pagination"
                          @paginationChange="paginationChange"
    />
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import AdminClient from '@/api/AdminClient';
import MeetingsClient from '@/api/MeetingsClient';
import AdminRequestsTable from './request-table/AdminRequestsTable.vue';
import moment from 'moment';

export default {
    components:{
        AdminRequestsTable,
        Loader
    },
    props:{
        from: {
            type: String,
            require: false
        },
        through: {
            type: String,
            require: false
        }
    },
    data() {
        return {
            adminClient: new AdminClient(this.$http),
            meetingsClient: new MeetingsClient(this.$http),
            count: 0,
            fetching: false,
            pagination: {
                limit: 10,
                page: 1,
                sortedColumn: 'start_time',
                sortedAsc: false
            }
        }
    },
    asyncComputed:{
        async appointments() {
            this.fetching = true;

            let fromDate = null;
            if (this.from)
                fromDate = moment(this.from).startOf('day').toISOString();

            let throughDate = null;
            if (this.through) {
                throughDate = moment(this.through).endOf('day').toISOString() 
            }

            const response = await this.meetingsClient.appointmentRequestReport(this.pagination, fromDate, throughDate)
            if (!response) {
                this.count = 0;
                this.fetching = false;
                return null;
            }
                this.count = response.count;
                const mappedResults = response.results.map(r => ({
                        start_time: moment(r.start).toDate(),
                        status: 'Pending',
                        existing_patient: r.patientType === 'Current Patient',

                        college: {
                            name: r.studentSchoolName
                        },

                        counselorName: `${r.counselorFirstName} ${r.counselorLastName}`,
                        studentDisplayName: `${r.studentFirstName} ${r.studentLastName}`,
                }));

                this.fetching = false;

                return mappedResults;
        }
    },
    methods: {
        paginationChange(pagination) {
            this.pagination = pagination
        }
    }
}
</script>

<style>

</style>
